













































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component({
    name: 'd-filter-form'
})
export default class DFilterForm extends Vue {
    @Prop({ default: () => [] }) readonly regionsList!: Array<{ code: string; name: string }>;
    public yearItem = 'Год';
    public currentYear = new Date().getFullYear();
    public yearsArr: number[] = [];
    public selectedRegion: any = null;
    public dictProgramVal: any | null = '';
    public programArr: any = [];
    public filterNameParams = [
        { name_ru: 'Программы', name_kk: 'Программы', name_en: 'Programs' }
    ];
    public all = {
        name_ru: 'Все',
        name_en: 'All',
        name_kk: 'Барлық',
        id: ''
    };
    private programId: string | null = null;

    @Watch('currentYear')
    @Watch('selectedRegion')
    @Watch('regionsList')
    private onFilterChange() {
        this.loadPrograms();
    }

    async mounted() {
        this.listOfYears(this.currentYear);
        await this.loadPrograms();
        await this.loadPassportData();
    }

    private onRegionChange(region: { code: string; name: string } | null) {
        this.loadPrograms();
    }

    private listOfYears(currentYear: number) {
        this.yearsArr = [];
        for (let i = currentYear; i >= 2021; i--) {
            this.yearsArr.push(i);
        }
    }

    public async reloadAvailablePrograms() {
        await this.loadPrograms();
    }

    private async loadPassportData() {
        this.programId = this.dictProgramVal?.id || '';
        this.$emit('listOfProgramsInPassport', {
            year: this.currentYear,
            region: this.selectedRegion,
            programId: this.programId
        });
    }

    private padLeadingZeros(num: string, size: number): string {
        let s = num;
        while (s.length < size) { s = s + '0'; }
        return s;
    }

    private async loadPrograms() {
        try {
            let regionCodes: string[] = [];

            if (this.selectedRegion?.code) {
                regionCodes = [this.padLeadingZeros(this.selectedRegion.code, 9)];
            } else {
                regionCodes = this.regionsList.map(r => this.padLeadingZeros(r.code, 9));
            }

            const query = new URLSearchParams({
                year: String(this.currentYear),
                codeKato: regionCodes.join(',')
            });

            const response = await fetch(`/api/program-passport/get-passport?${query}`);
            const data = await response.json();
            this.programArr = data
                .filter((passport: any) => passport.program)
                .map((passport: any) => this.setNameLangs(passport.program, ''));
            this.dictProgramVal = null;
            await this.loadPassportData();
        } catch (err) {
            this.makeToast('danger', 'Ошибка загрузки программ', err.toString());
        }
    }


    private setNameLangs(obj: any, codeName: string) {
        let txt = obj.name_ru || obj.name || '';
        if (codeName && obj[codeName]) {
            txt = `${obj[codeName]} - ${txt}`;
        }
        const el = Object.assign({}, obj);
        el.name = txt;
        return el;
    }

    private makeToast(variant: string, title: string, tostbody: string) {
        this.$bvToast.toast(tostbody, {
            title,
            autoHideDelay: 5000,
            variant,
            appendToast: true
        });
    }
}
